import { InformationCircleIcon } from "@heroicons/react/20/solid"
import Container from "./Container"
import useUser from "@/hooks/useUser"

const NotificationBanner = () => {
  const { user } = useUser()
  const hasUnverifiedFideId = user?.unverified_fide_id

  if (!hasUnverifiedFideId) return null

  return (
    <div className="border-b border-gray-200 bg-blue-50">
      <Container className="py-4" maxWidthClassName="max-w-none">
        <div className="flex">
          <InformationCircleIcon
            aria-hidden="true"
            className="h-5 w-5 shrink-0 text-blue-400"
          />
          <div className="ml-3 flex-1">
            <p className="max-w-4xl text-sm text-balance text-blue-700">
              You have entered a FIDE ID already assigned to an account that
              exists in ChessDrop. We will be in touch with you soon by email to
              verify your FIDE ID. Until verified, the FIDE ID on your newly
              created account will remain empty but you are free to use the
              account as normal.
            </p>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default NotificationBanner
